module.exports = __webpack_public_path__ + "static/media/longsuffering.094e477b.jpg";